export default __webpack_public_path__ + "static/media/pattern.24a1bd89.svg";